import {
    ChangeEvent, DataHeader, DataSourceMode, DataSourceModeChangeEvent, DropdownItem, LookupModelSearchEvent,
    LookupModelSelectionEvent
} from "@mcleod/components";
import { LogManager, StringUtil } from "@mcleod/core";
import { DuplicateId, DuplicateIdProps, LocationByTypeProps, LocationByTypeUtil } from "@mcleod/dispatch";
import { AutogenLayoutBrokeragePlanningProfile } from "./autogen/AutogenLayoutBrokeragePlanningProfile";
import { LMEGeneralSettings } from "@mcleod/general";


const log = LogManager.getLogger("lme.powerbroker.BrokeragePlanningProfile");
const viewBrokeragePlanningProfileURL = "lme/powerbroker/BrokeragePlanningProfile?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "brokerage_planning",
    screenName: "Brokerage Planning Profile",
    navigateToUrl: viewBrokeragePlanningProfileURL
}
const LOCATION_BY_TYPE_PROPS: LocationByTypeProps = {
    stateType: 'S',
    zoneType: 'Z',
    locationType: 'L',
    useDefault: true
}

export class BrokeragePlanningProfile extends AutogenLayoutBrokeragePlanningProfile {

    private LOCATION_FILTER_TYPE_ITEMS = [
        new DropdownItem("Z", "Zone"),
        new DropdownItem("S", "States"),
        new DropdownItem("C", "Zip code"),
        new DropdownItem("L", "Location")
    ];
    private textBeforeEdit: any;

    private orderRespCodesBeforeLookupModelSearchListener: (event: LookupModelSearchEvent) => void;

    override onLoad() {
        this.layoutProfileColor.profileDataSource = this.mainDataSource;

        this.textboxOrderIbType.items = this.LOCATION_FILTER_TYPE_ITEMS;
        this.textboxOrderObType.items = this.LOCATION_FILTER_TYPE_ITEMS;

        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxOrderIbType, this.textboxOrderIbZones, LOCATION_BY_TYPE_PROPS);
        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxOrderObType, this.textboxOrderObZones, LOCATION_BY_TYPE_PROPS);

        this.textboxOrderRespLevel.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            this.textboxOrderRespCodes.clear();
            this.activeRow?.set("order_resp_codes", null);

            if (this.orderRespCodesBeforeLookupModelSearchListener) {
                this.textboxOrderRespCodes.removeBeforeLookupModelSearchListener(this.orderRespCodesBeforeLookupModelSearchListener);
            }
            this.orderRespCodesBeforeLookupModelSearchListener = (event) => {
                if (this.activeRow?.isNull("order_resp_level")) {
                    event.stop();
                    return;
                }
                event.filter.hierarchy_level = this.activeRow?.getNumber("order_resp_level");
            };
            this.textboxOrderRespCodes.addBeforeLookupModelSearchListener(this.orderRespCodesBeforeLookupModelSearchListener);
            this.mainDataSource.displayDataInBoundComponent(this.textboxOrderRespCodes);
        });

        this.textboxOrderRespLevel.addChangeListener((event: ChangeEvent) => {
            const empty = StringUtil.isEmptyString(event.newValue);
            if (empty) {
                this.textboxOrderRespCodes.clear();
                this.activeRow?.set("order_resp_codes", null);
                this.mainDataSource.displayDataInBoundComponent(this.textboxOrderRespCodes);
            }
        });

        this.textboxBrokerageStatus.addBeforeLookupModelSearchListener(event => event.filter.is_active = "Y");

        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);

        this.switchIncludeOnHoldManifest.visible = LMEGeneralSettings.getSingleton().getDispatchControl()["enable_manifesting"] === "Y";
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxOrderType. */
    textboxOrderTypeBeforeLookupModelSearch(event) {
        event.filter.is_active = 'Y';
    }

    switchExactLaneMatchOnChange(event:ChangeEvent){
        this.textboxDefaultOriginFilter.visible = this.textboxDefaultDestFilter.visible = event.newValue;
    }
}
